import React, { Component } from 'react';
class Interests extends Component {
    render(){
        if(this.props.data){
        var interests = this.props.data.activities.map(function(activity){
            return <div key={activity.activities_title}><h3>{activity.activities_title}</h3>
            <div className="two columns">
                    <a target="_blank" rel="noopener noreferrer" href={activity.link}>
                        <img className="profile-pic"  src={"images/"+activity.image} alt={activity.Name+"LOGO"}/>
                    </a>
                </div>
                <p className="info">
                <span>&bull;</span> <em className="date">{activity.activities_duration}</em></p>
                <p>{activity.activities_description}</p>
            </div>
        })
    }
        return(
            <section id="interests">

                <div className="row">
                <div className="twelve columns collapsed">
                        <h1><span>{this.props.isGerman ? "Besondere Tätigkeiten" : "Extracurricular Activities"}</span></h1>
                    </div>

                    <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
                        {interests}
                    </div>
                </div>
                {/* <br/>
                <div className="row">
                   <div className="twelve columns collapsed">
                       <h1 style={{fontSize: '25px'}}><span>{this.props.isGerman ? "Sprachen" : "Languages"}</span></h1>
                   </div>

                   <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
                        
                    </div>
                </div> */}
                
             </section>
        );
    }
}
export default Interests;